import dynamic from 'next/dynamic';

import { UiLegacy } from '@silvertours/front-legacy-shared';
import {
  LogoList,
  MgpWrapper,
  CarigamiWrapper,
} from './CarigamiGarantie.styles';

const Garantie = dynamic(() =>
  import('./Garantie').then(module => module.Garantie),
);

const CarigamiGarantie = () => (
  <LogoList>
    <MgpWrapper key="gmp">
      <Garantie />
    </MgpWrapper>
    <CarigamiWrapper key="carigami">
      <UiLegacy.ImageSVG name="cg" />
    </CarigamiWrapper>
  </LogoList>
);
export { CarigamiGarantie };
